import React, { Component } from 'react';
import { document } from 'browser-monads';
import styled from '@emotion/styled';
import colors from 'styles/colors';
import dimensions from 'styles/dimensions';
import RichText from 'components/RichText';
import arrow from 'images/caption-arrow-2.png';

const LuminousContainer = styled.div`
  position: relative;
  max-width: 76.8rem;
  margin-left: auto;
  margin-right: auto;
  
  & + * {
    margin-top: 6.4rem;
  }
  
  &:last-child {
    margin-bottom: 6.4rem;
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    & + * {
      margin-top: 10.4rem;
    }
    
    &:last-child {
      margin-bottom: 10.4rem;
    } 
  }
`;

const LuminousVideo = styled.div``;

const LuminousCaption = styled.div`
  position: relative;
  right: 0.8rem;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.6rem;
  font-size: 1.6rem;  
  text-align: center;
  
  div {
    position: relative;
    padding-top: 1.6rem;
    width: 56.25vw;
    max-width: 16rem;
  }
  
  img {
    position: absolute;
    top: 0;
    right: calc(100% + 0.8rem);
    width: 5.6rem; 
    height: 4.6rem;
  }
  
  p {
    color: ${colors.teal200};
  }
  
  @media(min-width: ${dimensions.desktopUp}px) {
    right: -18.4rem; 
    
    div {
      max-width: 31.2rem;
      padding-top: 3.2rem;
    }
  }
`;

class LuminousPlayer extends Component {
  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://editorial.anyclip.com/anyclip-widget/lre-widget/prod/v1/src/lre.js';
    script.setAttribute('pubname', this.props.pubname || 'anyclipsitecom');
    script.setAttribute('widgetname', this.props.widget);

    if(this.props.plid) {
      script.setAttribute('data-plid', this.props.plid);
    }

    script.async = true;
    this.playerNode.appendChild(script);
  }

  render() {
    return (
      <>
        <LuminousContainer>
          <LuminousVideo
            ref={node => this.playerNode = node}
          />

          {this.props.caption && (
            <LuminousCaption>
              <div>
                <img src={arrow} alt='' loading="lazy"/>
                <RichText render={this.props.caption}/>
              </div>
            </LuminousCaption>
          )}
        </LuminousContainer>
      </>
    );
  }
}

export default LuminousPlayer;
